import {
  CREATE_ADMIN,
  GET_ADMIN,
  GET_ADMIN_DETAILS,
  UPDATE_ADMIN,
} from '../actionTypes';

const initialState = {
  admins: [],
  isLoading: false,
  error: false,
  message: '',
  newAdmin: false,
  adminOverview: {},
  totalPage: 1,
  currentPage: 1,
  selectedAdmin: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_ADMIN}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newAdmin: false,
      };
    case `${GET_ADMIN}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_ADMIN}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        admins: payload.data.data?.data || [],
        adminOverview: payload.data.data?.admin_overview || {},
        totalPage: payload.data.data?.total_page,
        currentPage: payload.data.data?.current_page,
      };

    case `${GET_ADMIN_DETAILS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_ADMIN_DETAILS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_ADMIN_DETAILS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedAdmin: payload.data.data,
      };

    case `${CREATE_ADMIN}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newAdmin: false,
      };
    case `${CREATE_ADMIN}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${CREATE_ADMIN}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newAdmin: true,
      };

    case `${UPDATE_ADMIN}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newAdmin: false,
      };
    case `${UPDATE_ADMIN}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${UPDATE_ADMIN}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newAdmin: true,
      };

    default:
      return state;
  }
}
